import React, { Component } from 'react'
import NegotiationStep from 'components/SalesWizard/Steps/NegotiationStep';
import { fetchSaleOrder, updateNegotiationSaleOrder, cleanSaleOrder } from "reducers/saleorder/saleorderActions";
import { connect } from 'react-redux';

import { withRouter } from 'react-router';


class SaleNegotiateUpdate extends Component {

    constructor(props) {
        super(props);
        this.state = {
            orderStatus: null,
            saleOrderId: null
        }
    }

    componentWillMount() {
        this.props.cleanSaleOrder();
        const queryParams = this.props.router.history.location.search;
        const params = new URLSearchParams(queryParams.replace("?", ""));

        const saleOrderId = params.get('saleOrderId');
        if (saleOrderId != null && saleOrderId !== "") {
            this.setState({ saleOrderId: saleOrderId });
            this.props.fetchSaleOrder(saleOrderId);
        }

        const orderStatus = params.get('orderStatus');
        if (orderStatus != null && orderStatus !== "") {
            this.setState({ orderStatus: orderStatus });
        }

    }

    render() {
        return (
            <div>
                <NegotiationStep
                    productEdit={true}
                    orderStatus={this.state.orderStatus}
                    saleOrderId={this.state.saleOrderId}
                    updateNegotiation={this.props.updateNegotiationSaleOrder} />
            </div>
        )
    }
}

const mapStateToProps = state => ({
});

export default connect(
    mapStateToProps,
    { fetchSaleOrder, updateNegotiationSaleOrder, cleanSaleOrder }
)(withRouter(SaleNegotiateUpdate));



// WEBPACK FOOTER //
// ./src/components/SaleNegotiateUpdate/SaleNegotiateUpdate.jsx